import { useMutation, useQueryClient } from "@tanstack/react-query";

import { api } from "../utils/api";
import { ApiError, ApiResponse } from "../types/api";
import { UiFlags, User } from "../types/auth";

export type UnitSystem = "metric" | "imperial";
export type FrameRatePreference = "low" | "high";

export type UpdateUserPreferencesInput = {
  unit_system?: UnitSystem;
  frame_rate_preference?: FrameRatePreference;
  auto_recalculate?: boolean;
  email?: string;
  /** E.164; the server normalizes spacing/dashes and rejects other formats.
   *  Empty string clears the number. */
  phone_number?: string;
  /** Merged server-side into the existing flags — send only what changed. */
  ui_flags?: UiFlags;
};

export const useUpdateUserPreferences = () => {
  const queryClient = useQueryClient();

  return useMutation<ApiResponse<User>, ApiError, UpdateUserPreferencesInput>({
    mutationFn: (input: UpdateUserPreferencesInput) =>
      api.request<ApiResponse<User>>("/api/me", {
        method: "PATCH",
        body: input,
      }),
    onSuccess: () => {
      // Keep any consumers of /api/me in sync if they exist in future.
      queryClient.invalidateQueries({ queryKey: ["me"] });
    },
  });
};
